import { forwardRef, memo } from "react";
import classnames from "classnames";
import { SolidEmpty } from "../icons";
import { FileTypeBase } from "../types";
import { getExtension, getMimeTypeInfo } from "../utils";

import styles from "./style.module.scss"

type FileSolidProps = FileTypeBase

export const FileSolid= memo(forwardRef<HTMLDivElement, FileSolidProps>((
  {
    isFolder = false,
    mimeType,
    className,
    videoIconType = "video01",
    fileExtension,
    ...props
  },
  ref
) => {
  const fileExt = getExtension(fileExtension);

  const { icon, type } = getMimeTypeInfo(mimeType, isFolder, videoIconType);

  return (
    <div
      className={classnames(
        className,
        styles.root,
        styles[fileExt as keyof typeof styles],
        styles[type as keyof typeof styles],
      )}
      ref={ref}
      {...props}
    >
      <SolidEmpty />
      {fileExt ? (
        <span className={classnames(styles.name)}>
          {fileExt}
        </span>
      ) : <i className={classnames(styles.iconMimeWrapper)}>{icon}</i>}
    </div>
  )
}));